export enum ClinicCollectPaymentMethodType {
  REQUIRED = 'required',
  OPTIONAL = 'optional',
}
